import BlockContent from '@sanity/block-content-to-react';
import React from 'react';
import { ButtonLinkType } from '../../../graphql-fragments/ButtonLink';
import serializers from '../../../serializers';
import { RawPortableText } from '../../../types/types';
import { CommonModuleProps, ModuleBackgroundColor } from '../../ModulesContent';
import ButtonLink from '../ButtonLink';
import ModuleLayout from '../ModuleLayout';
import * as styles from './TextListModule.module.scss';

export type TextListModuleProps = {
  backgroundColor: ModuleBackgroundColor;
  title: string;
  text?: string;
  items: Array<{
    title: string;
    _rawText: RawPortableText;
  }>;
  button?: ButtonLinkType;
  className?: string;
};

export function getModuleBgColor(props: TextListModuleProps): ModuleBackgroundColor {
  /**
   * The purpose of this function is to let other modules know which background color this module has.
   * Knowing this, we can use this function to make decisions about the layout and spacing between modules.
   */
  return props.backgroundColor;
}

function TextListModule(props: TextListModuleProps & CommonModuleProps): React.ReactElement {
  const {
    backgroundColor,
    title,
    text,
    items,
    button,
    className,
    moduleId,
    previousModuleBgColor,
  } = props;

  return (
    <ModuleLayout
      id={moduleId}
      className={className}
      title={title}
      text={text}
      currentModuleBgColor={getModuleBgColor(props)}
      previousModuleBgColor={previousModuleBgColor}
      childrenClassName={styles.contentContainer}
    >
      <div className={styles.textRowsContainer}>
        {items.map((item, i) => (
          <div className={styles.textRow} key={i}>
            <h3 className={styles.rowTitle}>{item.title}</h3>
            <ul>
              <li>
                <BlockContent
                  renderContainerOnSingleChild
                  className={styles.text}
                  blocks={item._rawText}
                  serializers={serializers}
                />
              </li>
            </ul>
          </div>
        ))}
      </div>
      {button && (
        <ButtonLink
          to={button}
          linkClassName={styles.buttonContainer}
          className={styles.button}
          largeButton
        >
          {button.title}
        </ButtonLink>
      )}
    </ModuleLayout>
  );
}

export default TextListModule;
